import React, { useState } from 'react'
import NavbarComponent from '../components/navbar-component/navbar-component'
import styled from 'styled-components';
import { Breadcrumb } from 'rsuite';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FooterComponent from '../components/common/footer-component/footer-component';
import { Box, Button, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { BaseUrl } from '../api/axios';
import { Configurations } from '../config';
import DownloadIcon2 from '../assets/download-icon.png';
import ListIcon from '../assets/list-icon.png';

export default function DownloadListPage() {

  const location = useLocation();
  const { title="", subList=[] } = location.state || {};

    const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  color: #333;
`;

const Title = styled.h1`
  text-align: center;
  font-size: 1.8em;
  margin-bottom: 20px;
  font-family: Arial, sans-serif;
`;
const navigate = useNavigate();


const downloadLinks = [
    {
      title: "Nomination Form – University Provident Fund",
      //description: "A clean and modern resume template for professionals.",
      url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    },
    {
      title: "Information for Recruitment of Contract and Temporary Employees",
      //description: "A comprehensive proposal template for project planning.",
      url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Information-for-Recruitment-of-Contract-and-Temporary-Employees.pdf",
    },
    {
      title: "Check List - Application for the Post of Professor",
      //description: "An example business report format for corporate use.",
      url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Document-Check-List-for-the-Professor-Application.docx",
    }
  ];

  const LinkCard = ({ href, text, icon: IconComponent,cardIcon }) => {
    return (
      <Card variant="outlined" sx={{marginBottom:1}}>
        <CardActionArea 
          component="a" 
          href={href} 
          target='_blank'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start', 
            p: 2,
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              textDecoration: 'none',
            },
          }}
        >
          {/* <IconComponent style={{ color: '#8B0000', marginRight: 16 }} /> */}
          <img src={cardIcon} alt="donwnload icon" style={{width:30,marginRight:10}} />
          <Typography variant="body1">
            {text}
          </Typography>
        </CardActionArea>
      </Card>
    );
  };

  const DownloadItem = ({ href, text }) => (
    <CardActionArea
      component="a"
      href={href}
      target='_blank'
      download
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', 
        textDecoration: 'none',
        color: 'inherit',
        px: 2,
        py: 1,
        '&:hover': {
          backgroundColor: '#f5f5f5',
          textDecoration: 'none',
        },
      }}
    >
      {/* <DownloadIcon sx={{ color: 'brown', mr: 2 }} /> */}
      <img src={DownloadIcon2} alt="donwnload icon" style={{width:30,marginRight:10}} />
      <Typography variant="body1">{text}</Typography>
    </CardActionArea>
  );

  return (
   <>
   <NavbarComponent />
   <div class="container">
      <div>
        <Breadcrumb separator={">"}>
            <Breadcrumb.Item as={Link} onClick={()=>navigate("/home")} href="#">
            Home
            </Breadcrumb.Item>
            <Breadcrumb.Item  as={Link} onClick={()=>navigate("/download")} href="#" >
            Downloads
            </Breadcrumb.Item>
            <Breadcrumb.Item  >
            List
            </Breadcrumb.Item>
        </Breadcrumb>
    </div>
    </div>

   <Container>
        
      <Title>{title}</Title>

      {subList.map((link, index) => (
          <>
          {link.type == "link" && (
              <LinkCard 
              href={link.url}
              text={link.title} 
              cardIcon={DownloadIcon2}
            />
          )}

            {link.type == "list" && (
                <Box
                sx={{
                  border: '1px solid #ccc',
                  borderRadius: 1,
                  p: 2,
                  boxShadow: 1,
                  marginBottom:1,
                }}
              >
                <Typography variant="h6" sx={{ mb: 2 }}>
                  {link.title}
                </Typography>

                
                <div key={index}>
                  {link.subList.map((item, idx) => (
                   <DownloadItem
                    href={item.url}
                    text={item.title}
                 />
                  ))}
                </div>

              </Box>
            )}


        {link.type == "list2" && (
                <Box
                sx={{
                  border: '1px solid #ccc',
                  borderRadius: 1,
                  p: 2,
                  boxShadow: 1,
                  marginBottom:1,
                }}
              >
                <Typography variant="h6" sx={{ mb: 2 }}>
                  {link.title}
                </Typography>

                
                <div key={index}>
                  {link.subList.map((item, idx) => (

                    <>
                    
                     <div style={{marginLeft:30}}>
                     <Typography variant="h6" sx={{ mb: 2 }}>
                      {item.title}
                    </Typography>
                        {item.subList.map((item2, idx2) => (
                            <DownloadItem
                              href={item2.url}
                              text={item2.title}
                          />
                        ))}
                      </div>
                  
                    </>
                     
                  ))}
                </div>

              </Box>
            )}
          </>
        ))}

        


      <div style={{ padding:200 }}></div>
    </Container>
    <FooterComponent />
   </>
  )
}
